export default __webpack_public_path__ + "static/media/ebayListingDataBoxIdExample.e80f81ed.png";